/* The one line a pattern-matched finding carries.
 *
 * This file used to hold the model layer's whole notice — drop counts, the
 * reasons candidates were discarded, a retry control. That surface reported a
 * run that no review performs: matching clauses by pattern is the one stage
 * that would send text out of the browser, and Ceiling never does it as part
 * of reading a document. See PATTERNS_NOT_RUN in src/data/analysisRun.ts, and
 * the note in docs/redesign/REPORT.md.
 *
 * What survives is the caveat, because the worked example carries findings
 * that were matched that way by hand, and a reviewer reading one has to be
 * told which kind it is. */

import './ModelLayerNotice.css';

export function ModelAssistedCaveat() {
  return (
    <p className="mln__caveat">
      Matched to a clause by pattern, not by arithmetic. Verify the quote against
      the source document before acting.
    </p>
  );
}
